<!--
 * @Author: lan.h
 * @Date: 2022-05-12 10:11:52
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-17 15:01:13
 * @Description: 专题pro、文章、快讯下实体信息
-->
<template>
  <div>
    <div class="article-entity">
      <!-- 单个实体 -->
      <div class="entity" v-if="entityInfos.length == 1">
        <h1 class="c_name"><span @click="toEntity(entityInfos[0])">{{entityInfos[0].shortName}}</span></h1>
        <div class="desc" v-if="entityInfos[0].type != 3 && (entityInfos[0].description || entityInfos[0].roundId)">
          {{entityInfos[0].description ? entityInfos[0].description : ''}}
          <i v-if="entityInfos[0].description && entityInfos[0].roundId">|</i>
          {{entityInfos[0].roundId | deal('round', 'name', '')}}
        </div>
        <div class="desc" v-if="entityInfos[0].type == 3 && (entityInfos[0].hospitalLevel1 || entityInfos[0].hospitalLevel2 || entityInfos[0].addressId)">
          {{entityInfos[0].hospitalLevel1 | deal('hlht_level1', 'name', '')}}
          {{entityInfos[0].hospitalLevel2 | deal('hlht_level2', 'name', '')}}
          <i v-if="(entityInfos[0].hospitalLevel1 || entityInfos[0].hospitalLevel2) && entityInfos[0].addressId">|</i>
          {{entityInfos[0].addressId | addressDeal(2, [], '')}}
        </div>
      </div>
      <!-- 多个实体 -->
      <div class="entity-more" v-if="entityInfos.length > 1">
        <h1 class="c_name" v-for="a,a_index in entityInfos" v-if="a_index < 5" :key="a_index" @click="toEntity(a)">{{a.shortName}}</h1>
      </div>
      <div class="comp-src-name"><i class="iconfont">&#xe6a7;</i>{{entityInfos.length==1 && entityInfos[0].type == 3 ? '医疗机构' : '企业' }}数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click="haddleApplyTry2(32)"> 提供支持</div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['haddleApplyTry2'],
  props: ['entityInfos'],
  methods: {
    toEntity(a) {
      if(a.type == 0){
        const href = this.$store.state.index_path + '/companyDetail/' + a.uid
        window.open(href, '_blank')
      }else if(a.type == 1){
        const href = this.$store.state.index_path + '/orgDetail/' + a.uid
        window.open(href, '_blank')
      }else if (a.type == 3) {
        const href = this.$store.state.index_path + '/hospitalDetail/' + a.uid
        window.open(href, '_blank')
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.article-entity
  background #FFFCF8
  padding 14px 20px
  margin-top 10px
  width 100%
  display flex 
  align-items center 
  justify-content space-between
  .entity
    flex 1
    .e_name, .c_name
      font-size 16px
      font-weight 400
      color #333333
      line-height 18px
      span 
        position relative
        line-height 1
    .c_name
      cursor pointer
      span
        &::after
          border solid #000
          border-width 0 1px 1px 0
          display inline-block
          padding 3px
          transform rotate(-45deg)
          position absolute
          top 8px
          right -12px
          content ''
        &:hover 
          color #FA5A00
          transition all .5s
          &::after
            transition all .5s
            border-color #FA5A00
    .desc
      font-size 12px
      font-weight 500
      color #666666
      line-height 16px
      margin-top 10px
      i 
        font-size 12px
        font-style normal 
        margin 0 10px 
        color #eee
  .entity-more
    flex 1
    line-height 22px
    .c_name
      font-size 14px
      font-weight 400
      color #333333
      line-height 1
      display inline-block
      margin 0 10px
      position relative
      cursor pointer
      transition all .5s
      line-height 1
      &:hover 
        color #FA5A00
    .c_name+.c_name
      &::after
        position absolute
        left -10px 
        top 1px
        width 1px 
        height 100%
        background #eee
        content ''
    .c_name:first-child
      margin-left 0
.comp-src-name
  img 
    opacity 0.6
    &:hover
      opacity 0.8
</style>